import type { MaterialNames } from "@/components/material_symbol_names";

export type DashboardGreeting = {
  phrase: string;
  tabIcon: MaterialNames;
  dateLabel: string;
};

function getHourInTimeZone(timeZone: string, now: Date): number {
  const hourPart = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour: "numeric",
    hour12: false
  })
    .formatToParts(now)
    .find((part) => part.type === "hour");

  return Number(hourPart?.value ?? now.getHours());
}

function formatDateLabel(timeZone: string, now: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    month: "short",
    day: "numeric"
  })
    .format(now)
    .toUpperCase()
    .replace(".", "");
}

export function resolveDashboardGreeting(now: Date, timeZone: string): DashboardGreeting {
  const hour = getHourInTimeZone(timeZone, now);
  const dateLabel = formatDateLabel(timeZone, now);

  if (hour < 6) {
    return {
      phrase: "You're up early",
      tabIcon: "raven",
      dateLabel
    };
  }

  if (hour >= 21) {
    return {
      phrase: "We got this",
      tabIcon: "dark_mode",
      dateLabel
    };
  }

  if (hour < 12) {
    return {
      phrase: "Good morning",
      tabIcon: "local_cafe",
      dateLabel
    };
  }

  if (hour < 17) {
    return {
      phrase: "Good afternoon",
      tabIcon: "sunny",
      dateLabel
    };
  }

  return {
    phrase: "Good evening",
    tabIcon: "wb_twilight",
    dateLabel
  };
}
